import {fetchARMetrics} from "../network/ARStationMetricsAPI"

export const WorkstationMetricsViewReducer = (state, action) => {
    switch (action.type) {
        case "CHANGE_GRANULARITY": {
            return {
                ...state,
                granularity: action.data.granularity
            };
        }

        case "LOAD_VIEW": {
            const {baseUrl, dispatcher, filterDispatcher, stationConfig} = action.data;
            fetchARMetrics(dispatcher, filterDispatcher, stationConfig, baseUrl)
            return state;
        }

        case "RECEIVE_METRICS": {
            return {
                ...state,
                metricsTableData: {
                    ...action.data
                }
            }
        }
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/components/workstationMetrics/reducers/WorkstationMetricsViewReducer.js